import {
	SET_FORM_STATE
} from '../actions/ReportRFCountersActions';

const initialState = {
	formState:
	{
		isValid: false,
		values: {},
		touched: {},
		errors: {}
	},
};

const reportRFCountersReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					default: {
						return state;
					}
	}
};

export default reportRFCountersReducer;
